export const setUrlParameter = (key: string, value: string | null) => {
    const url = new URL(window.location.href);
    if (value === null || value === '') {
        url.searchParams.delete(key);
    } else {
        url.searchParams.set(key, value);
    }
    window.history.replaceState({}, '', url.toString());
}

export const getUrlParameter = (key: string): string | null => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
}
